import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Drawer, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { useState } from 'react';
import { useApi } from 'Service/axios';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { width } from '@mui/system';

export default function AddModal({ open, setOpen, get }) {
    const style = {
        width: '300px',
        padding: '50px 60px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    };

    const api = useApi();

    const handleClose = () => {
        setOpen(false);
        setPercentagem('');
        setStateBr([]);
    };

    const [stateBr, setStateBr] = useState([]);
    const [percentagem, setPercentagem] = useState('');

    const handleChange = (event) => {
        const {
            target: { value }
        } = event;
        setStateBr(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value
        );
    };

    const estadosBrasil = [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
        'EX'
    ];

    const registerIcms = async () => {
        if (stateBr.length === 0 || percentagem === '') return toast.warn('Preencha os campos corretamente');
        const stateSelected = stateBr.join('/');
        const payload = {
            state: stateSelected,
            percentage: Number(percentagem)
        };

        try {
            await api.registerIcms(payload);
            toast.success('ICMS cadastrado com sucesso');
            handleClose();
            get();
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <div>
            <Drawer open={open} onClose={handleClose} anchor="right">
                <Box sx={style}>
                    <div>
                        <h4>Cadastro de ICMS</h4>
                    </div>
                    <div>
                        <FormControl sx={{ width: '100%', marginBottom: '20px' }}>
                            <InputLabel id="demo-multiple-name-label">Estados</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                label="Estados"
                                multiple
                                value={stateBr}
                                onChange={handleChange}
                            >
                                {estadosBrasil.map((state) => (
                                    <MenuItem key={state} value={state}>
                                        {state}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <TextField
                                label="Porcentagem"
                                type="number"
                                value={percentagem}
                                onChange={(event) => setPercentagem(event.target.value)}
                            />
                        </FormControl>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <Button variant="contained" sx={{ width: '300px' }} onClick={registerIcms}>
                            Salvar
                        </Button>
                    </div>
                </Box>
            </Drawer>
        </div>
    );
}
